/**
 * @module:  我的任务UI store
 * @author: Liang Huang
 * @date: 2020-03-19 17:13:49
 */
import { observable } from 'mobx';

class MyTaskUI {
  //  筛选抽屉
  @observable filterDrawer: boolean = false;
  //  项目抽屉
  @observable projectDrawer: boolean = false;
}

export default MyTaskUI;
